<template>
	<div>

		<Editar :anexo="formData" :parent="this" :showForm="showFormEdit"/>

		<TableView
			registerName="Inserir Anexo"
			:onRegister="(this.validarPermissao(576) ? onRegister : null)" 
			:onEdit="onEdit"
			:onDelete="onDelete"
			:onSearch="getLtcatAnexo"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="loadingTable"
			:pagination="pagination"
			:response="response"
		>
		</TableView>

	</div>
</template>

<script>
	
	import TableView from 'common/table'
	import Rest from 'common/rest'
	import Editar from './editar'

  	export default {
  		name:"exame",
  		components: {TableView,Editar},
		mixins:[Rest],
		props:{
			ltcat:{
				type: Object,
				default: null
			}
		},
		watch: {
			'$store.state.ltcat.data'(){
				this.getLtcatAnexo();
			},
		},
  		data () {
		   	return {
		   		formData:{},
				pagination:{},
				response:{},
		   		tableHead:[
					{
		                key: 'id',
						sortable: true,
						label: 'Cód',
					},
					{
		                key: 'descricao',
						sortable: true,
						label: 'Descrição',
					},
					{
		                key: 'imagem',
						show_arquivo:true,
						label: 'Anexo',
		            },
					{
						key: 'status',
						show_status:true,
						label: 'Status',
		            },
					{
		                key: 'updated_at',
						sortable: true,
						show_user:true,
						label: 'Atualização',
		            },
		   		],
		   		tableData:[],
		   		loadingTable:false,
		   		showFormEdit:false,

			}
		},
		beforeDestroy(){
			this.tableData = [];
		},
		created(){
			
		},

		mounted: function() {
			this.getLtcatAnexo();
		},	

		methods: {

			onRegister: function(){
				this.showFormEdit = !this.showFormEdit;
				this.formData = {
		   			id:0,
		   		};
			},

			onEdit: function(data){
				this.showFormEdit = !this.showFormEdit;
				this.formData = {
					id:data.id,
		   			nome:data.nome,
		   			usuario:data.usuario,
		   			updated_at:data.updated_at,
				};
			},

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

                    self.loadingTable = true;

                    this.post('/ltcat/anexo/'+this.$store.state.ltcat.data.id+'/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.loadingTable = false;

                        if(result.status == 200){
                            self.getLtcatAnexo();
                            self.edMsg('Registo excluido com sucesso');
                        }
                    });

                });
			},

			getLtcatAnexo: function(_search,_page,_pagination){
				
				if(!this.$store.state.ltcat.data)return;

				this.loadingTable = true;
				this.response = {};

				this.get('ltcat/anexo/'+this.$store.state.ltcat.data.id,{search:_search,page:_page,pagination:_pagination}).then((result)=>{

		            result = result[0];
					this.response = result;

		             if(result.status == 200){

		             	var
		             		data = result.data.data,
		             		tableData = [],
		             		pagination = result.data

		             	for (var i = 0; i < data.length; i++) {

							data[i].collapse = null;

		             		var item = {
		             			'id': data[i].id,
		             			'descricao': data[i].descricao,
								'link': (data[i].arquivo ? data[i].arquivo.url : ''),
								'updated_at': this.toDate(data[i].updated_at),
								'imagem': data[i].arquivo,
								'status': (data[i].obs ? data[i].obs : ''),
		             			_data:data[i],
		             			options:{
									disable_delete:(!this.validarPermissao(576) || (data[i].tipo_status && data[i].tipo_status.id != 79)),
									disable_edit:(!this.validarPermissao(576) || (data[i].tipo_status && data[i].tipo_status.id != 79)),
								},
		             			buttons:[]
		             		};

		             		tableData.push(item);
		             	}

		             	this.pagination = pagination;
		             	this.tableData = tableData;
		             	this.loadingTable = false;
		             }
	            });
			},

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?5c51bb90